import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../../StyledComponents';
import FirstNameIcon from '../../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../../assets/formComponents/emailIcon.svg';
import CompanyIcon from '../../../assets/formComponents/companyIcon.svg';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { Link, navigate } from 'gatsby';
import { validatePhone } from '../../../globalFunctions';
import apiHost from '../../../apiHost';
import Checkbox from '../../UIComponents/Checkbox';
import Fade from 'react-reveal/Fade';
import PhoneInputClass from '../ContactUs/PhoneInput';
import { getLanguageFromPath } from '../../../helpers';

const RequestDemoFormComponent = styled.div`
  font-size: 14px;
  text-align: center;
  /* position: absolute;
  right: 2rem;
  top: 3rem; */
  /* width: fit-content; */

  padding-right: 18rem;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-right: 14rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-right: 5rem;
  }
  @media (max-width: 1000px) {
    position: relative;
    top: unset;
    display: grid;
    justify-content: center;
    right: unset;
    padding: 0rem;
    width: 90%;
    max-width: 450px;
    margin: auto;
    margin-top: 2rem;
  }
`;
export const RequestDemoFormContainer = styled.div`
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: fit-content;
  box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
  background-color: #ffffff;
  display: grid;
  /* justify-items: center; */
  padding-top: 2rem;
  padding-bottom: 3rem;
  @media (max-width: 520px) {
    /* width: 100%; */
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const RequestDemoTitle = styled.h1`
  font-size: 28px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
`;

const BlueButtonNew = styled(BlueButton)`
  margin-top: 0rem;
  min-width: 18rem;
  margin: 0 !important;
  margin-top: 10px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    name: '',
    email: '',
    company: '',
    date: new Date(),
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    contact: '',
    deviceNumber: 0,
    contactFocus: false,
    nameError: false,
    emailError: false,
    companyError: false,
    contactError: false,
    deviceNumberError: false,
    preferredDateError: false,
    submitError: false,
    loaded: false,
    langKey: 'en',
    consentCheckbox: false,
    consentError: false,
  };

  isAllValid = () =>
    !(this.state.companyError ||
    this.state.contactError ||
    this.state.nameError ||
    this.state.preferredDateError ||
    // this.state.deviceNumberError ||
    this.state.emailError ||
    this.state.consentError ||
    this.props.messages.locale !== 'en'
      ? !this.state.consentCheckbox
      : false);

  validateAll = () => {
    this.validateCompany();
    this.validateDeviceCount();
    this.validateContact();
    this.validateFullName();
    this.validateEmail();
    if (!this.state.consentCheckbox && this.props.messages.locale !== 'en') {
      this.setState({
        consentError: true,
      });
    }
  };

  componentDidMount() {
    this.setState({
      loaded: true,
      langKey: getLanguageFromPath(window.location.pathname)
        ? getLanguageFromPath(window.location.pathname)
        : 'en',
    });
  }
  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'pricing');
    // navigate('/submitted');
    if (this.props.endState) {
      navigate(
        this.state.langKey !== 'en'
          ? `/${this.state.langKey}${this.props.endState}`
          : `${this.props.endState}`
      );
    } else {
      navigate(
        this.state.langKey !== 'en'
          ? `/${this.state.langKey}/submitted`
          : '/submitted'
      );
    }
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = (token: any) => {
    this.validateAll();
    if (this.isAllValid()) {
      localStorage.setItem('customerName', `${this.state.name}`);
      localStorage.setItem('demoTime', `${this.state.date.toISOString()}`);
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/5768e2d9-8d0c-45df-a314-28a323e59298',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'phone',
              value: `${
                this.state.defaultCountry
                  ? `+${this.state.defaultCountry.code} `
                  : ''
              }${this.state.contact.trim()}`,
            },
            {
              name: 'company',
              value: this.state.company,
            },
            // {
            //   name: 'number_of_device',
            //   value: this.state.deviceNumber,
            // },

            {
              name: 'language_key',
              value: this.state.langKey,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.setState({
            companyError: false,
            contactError: false,
            nameError: false,
            emailError: false,
            deviceNumberError: false,
            preferredDateError: false,
            email: '',
            name: '',
            company: '',
            contact: '',
            date: '',
            deviceNumber: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.number_of_device')) {
                this.setState({ deviceNumberError: true });
              } else if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };

  validateEmail = (isNotOnFocus?: any) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  validateCompany = () => {
    if (this.state.company.length === 0 || this.state.company.length > 30) {
      this.setState({
        companyError: true,
      });
    } else {
      this.setState({
        companyError: false,
      });
    }
  };
  validateDeviceCount = () => {
    if (this.state.deviceNumber <= 0) {
      this.setState({
        deviceNumberError: true,
      });
    } else {
      this.setState({
        deviceNumberError: false,
      });
    }
  };
  //   Input Recievers
  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };

  validateContact = () => {
    if (!validatePhone(this.state.contact)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage:
          this.props.messages?.AllFormValidationMessagesValidPhoneNumber ??
          'Please enter a valid contact number',
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  //   Input Recievers

  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleCompanyChange = (event: any) =>
    this.setState({ company: event.target.value });
  handleDeviceChange = (event: any) =>
    this.setState({ deviceNumber: event.target.value });
  handleContactChange = (event: any) =>
    this.setState({ contact: event.target.value });
  onKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-/.test(keyValue)) {
      event.preventDefault();
    }
  };

  handleFocusContact = () => this.setState({ contactFocus: true });
  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer id={this.props.formId}>
          <RequestDemoTitle>
            {this.props?.messages?.PricingPageContactUsFormTitle ??
              'Connect with Esper'}
          </RequestDemoTitle>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              aria-label="Full Name"
              backgroundImage={this.state.loaded && FirstNameIcon}
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={
                this.props?.messages?.PricingPageContactUsFormName ??
                'Full Name'
              }
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />
                  {this.props.messages?.AllFormValidationMessagesValidName ??
                    'Please enter a valid name'}
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? this.props.messages
                          ?.AllFormValidationMessagesValidName ??
                        'Please enter a valid name'
                      : this.props.messages?.AllFormValidationMessagesName ??
                        'Please enter the name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              aria-label="Email"
              backgroundImage={this.state.loaded && EmailIcon}
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={
                this.props?.messages?.PricingPageContactUsFormEmail ??
                'Work Email'
              }
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.messages?.AllFormValidationMessagesValidEmail}
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? this.props.messages?.AllFormValidationMessagesValidEmail
                      : this.props.messages?.AllFormValidationMessagesEmail}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>

          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="company"
              value={this.state.company}
              aria-label="Company"
              backgroundImage={this.state.loaded && CompanyIcon}
              maxLength={149}
              onChange={this.handleCompanyChange}
              onBlur={this.validateCompany}
              error={this.state.companyError || this.state.submitError}
              type="text"
              placeholder={
                this.props?.messages?.PricingPageContactUsFormCompany ??
                'Company'
              }
              name="Company"
            />
            <PasswordMatchError id="company-error">
              {this.state.companyError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />
                  {this.props.messages
                    ?.AllFormValidationMessagesValidCompanyName ??
                    'Please enter a valid company name'}
                </>
              ) : (
                this.state.companyError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? this.props.messages
                          ?.AllFormValidationMessagesValidCompanyName ??
                        'Please enter a valid company name'
                      : this.props.messages?.AllFormValidationMessagesCompany}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <PhoneInputClass
            handleFocusContact={this.handleFocusContact}
            handleContactChange={this.handleContactChange}
            validateContactNumber={this.validateContact}
            handleCountrySelect={this.handleCountrySelect}
            defaultCountry={this.state.defaultCountry}
            contactNumber={this.state.contact}
            contactError={this.state.contactError}
            submitError={this.state.submitError}
            messages={this.props.messages}
          />
          <div
            style={{
              display: 'grid',
              maxWidth: '420px',
            }}
          >
            {this.props?.messages?.locale === 'de' ? (
              <Checkbox
                label={
                  <div style={{ textAlign: 'left' }}>
                    {this.props.messages?.locale ? (
                      <div>
                        {this.props.messages?.WebsiteConsentText1}{' '}
                        <Link
                          to={`${
                            this.props?.messages?.locale !== 'en'
                              ? `/${this.props?.messages?.locale}/privacy-policy`
                              : '/privacy-policy'
                          }`}
                        >
                          {' '}
                          {this.props.messages?.WebsiteConsentText2}{' '}
                        </Link>
                        {this.props.messages?.WebsiteConsentText3}{' '}
                      </div>
                    ) : (
                      <div>
                        {
                          'By submitting this form, you consent to the collection and processing of your personal data under the terms set out in our'
                        }{' '}
                        <Link
                          to={`${
                            this.props?.messages?.locale !== 'en'
                              ? `/${this.props?.messages?.locale}/privacy-policy`
                              : '/privacy-policy'
                          }`}
                        >
                          {' privacy policy.'}
                        </Link>
                        {
                          'You have the right to access, modify and delete your personal data. You can exercise this right by contacting partner@esper.io. You can unsubscribe from these communications at any time. '
                        }
                      </div>
                    )}
                  </div>
                }
                checked={this.state.consentCheckbox}
                onChange={() =>
                  this.setState(
                    {
                      consentCheckbox: !this.state.consentCheckbox,
                    },
                    () =>
                      this.setState({
                        consentError:
                          this.state.consentError && !this.state.consentCheckbox
                            ? true
                            : false,
                      })
                  )
                }
              />
            ) : this.props?.messages?.locale === 'en' ? (
              <div style={{ textAlign: 'left', marginTop: '-5px' }}>
                <Checkbox
                  label={
                    <div style={{ textAlign: 'left' }}>
                      {this.props.messages?.locale ? (
                        <div>{this.props.messages?.WebsiteConsentText1}</div>
                      ) : (
                        <div>
                          {
                            'By submitting this form, you consent to the collection and processing of your personal data under the terms set out in our'
                          }{' '}
                          <Link
                            to={`${
                              this.props?.messages?.locale !== 'en'
                                ? `/${this.props?.messages?.locale}/privacy-policy`
                                : '/privacy-policy'
                            }`}
                          >
                            {' privacy policy.'}
                          </Link>
                          {
                            'You have the right to access, modify and delete your personal data. You can exercise this right by contacting partner@esper.io. You can unsubscribe from these communications at any time. '
                          }
                        </div>
                      )}
                    </div>
                  }
                  checked={this.state.consentCheckbox}
                  onChange={() =>
                    this.setState({
                      consentCheckbox: !this.state.consentCheckbox,
                    })
                  }
                />
              </div>
            ) : null}
            <Fade when={this.state.consentError}>
              <PasswordMatchError id="consent-error">
                {this.state.consentError === true && (
                  <>
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.props.messages?.WebsiteConsentErrorValidationText ??
                      'Please complete the required field'}
                  </>
                )}
              </PasswordMatchError>
            </Fade>
          </div>

          <div style={{ display: 'grid', marginTop: '0px' }}>
            <BlueButtonNew
              id={`${this.props.formId}__submit`}
              onClick={this.sendData}
            >
              {this.props?.messages?.PricingPageContactUsFormSubmitButton ??
                'Submit'}
            </BlueButtonNew>
          </div>
          {this.props?.messages?.locale !== 'de' ? (
            <div style={{ marginTop: '15px' }}>
              {this.props.messages?.WebsiteConsentText2}
              <Link
                to={`${
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/terms-of-service`
                    : '/terms-of-service'
                }`}
              >
                {' '}
                {this.props.messages?.WebsiteConsentText3}{' '}
              </Link>
              <Link
                to={`${
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/privacy-policy`
                    : '/privacy-policy'
                }`}
              >
                {' '}
                {this.props.messages?.WebsiteConsentText4}{' '}
              </Link>
            </div>
          ) : null}
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
